import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import colors from '../../../configuration/colors'

const LabelContainer = styled.div`
 background: ${(props) => props.isPublished ? 'none' : colors.aluminum};
 color: ${(props) => props.isPublished ? colors.jade : colors.white};
 border-radius: 4px;
 padding: 5px 12px;
 width: min-content;
`

export const PublishLabel = ({
  isPublished
}) => {
  return (
    <LabelContainer isPublished={isPublished}>
      {isPublished !== null && isPublished ? 'Published' : 'Draft'}
    </LabelContainer>
  )
}

PublishLabel.propTypes = {
  isPublished: PropTypes.bool.isRequired
}

export default PublishLabel



// WEBPACK FOOTER //
// ./src/components/mini/MyCourses/PublishLabel.js